import { render, staticRenderFns } from "./WidgetMetaField.vue?vue&type=template&id=5851460c"
import script from "./WidgetMetaField.vue?vue&type=script&lang=js"
export * from "./WidgetMetaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports